const NS = 'OverlayNav';

export const ACTION_OVERLAY_NAV_OPEN = `ui:${NS}:open`;

export default NS;
